<div class="rating">
  @for (item of starArray; track $index; let i = $index) {
  <div class="rating-label me-2 checked" [ngbTooltip]="`${i +1} คะแนน`">
    <i
      role="button"
      tabindex="0"
      (click)="selectStar(i + 1)"
      (keydown.enter)="selectStar(i + 1)"
      (keydown.space)="selectStar(i + 1)"
      [class]="`bi ${iconSize}`"
      [ngClass]="{
        'bi-star-fill': i + 1 <= rating,
        'bi-star': i + 1 > rating,
        'cursor-pointer': modeForm
      }"
    ></i>
  </div>
  }
</div>
